import { IDBBill } from './db.gen';

/**
 * BillPayable is a superset of bills that includes all bills for a given month
 */
export interface IDBBillPayable extends Omit<IDBBill, 'b_workspace_id'> {
    b_ids: string;
}
